import { css } from '@emotion/react'
import { breakpoint, size } from '@twistopayments/design-system/styles'

export const media = css`
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${size[20]};

  ${breakpoint.up('md')} {
    margin-bottom: ${size[24]};
  }
`
